<script setup>
import { computed } from 'vue'

const serviceCount = computed(() => {
    return  window.prebook.services
})
</script>
<template>
    <div class="service-loader">
        <!-- loader item -->
        <div v-for="i in serviceCount" class="service-loader__item">
            <div class="service-loader__item-content">
                <div class="service-loader__item-content-image"></div>
                <div class="service-loader__item-content-info">
                    <div class="service-loader__item-content-info-title"></div>
                    <div class="service-loader__item-content-info-subtitle"></div>
                </div>
            </div>
            <div class="service-loader__item-price"></div>
        </div>
    </div>
</template>